<template>
    <VehicleList
        v-if="!isLoading"
        :vehicles="relatedVehicles"
        class="related-vehicles-list"
        :list-name="VEHICLE_LIST_ANALYTICS_NAMES.related"
    />
</template>

<script>
import { getFilterValue } from '~/helpers/queryParser';
import { AVAILABLE_BETWEEN } from '~/config/filterKeys';
import { VEHICLE_LIST_ANALYTICS_NAMES } from '~/config/analytics';

import VehicleList from '~/components/vehicles/VehicleList.vue';

export default {
    components: {
        VehicleList,
    },
    props: {
        id: {
            type: Number,
            default: null,
        },
        count: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            relatedVehicles: [],
            isLoading: false,

            VEHICLE_LIST_ANALYTICS_NAMES,
        };
    },
    fetch() {
        this.getRelatedVehicles();
    },
    computed: {
        selectedDates() {
            return getFilterValue(this.$route.query, AVAILABLE_BETWEEN);
        },
    },
    watch: {
        selectedDates: {
            handler() {
                this.getRelatedVehicles();
            },
            deep: true,
        },
    },
    methods: {
        getRelatedVehicles() {
            this.isLoading = true;
            const filters = {};
            const { from, to, mode } = this.selectedDates;

            if (from && to) {
                filters[AVAILABLE_BETWEEN] = `${from},${to},${mode}`;
            }

            this.$vehicleService
                .getRelated(this.id, filters, this.count)
                .then(assets => {
                    this.relatedVehicles = assets;
                    this.isLoading = false;
                })
                .catch(err => {
                    this.$sentry.captureException(err);
                });
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.related-vehicles-list {
    .vehicle-list__item {
        max-width: 100%;
        width: calc(100% - 20px);

        @include sm {
            max-width: 62%;
        }

        @include breakpoint(667px) {
            max-width: 47%;
        }

        @include breakpoint(1020px) {
            max-width: 23%;
            @include font-size(12px);
        }

        @include breakpoint(1500px) {
            @include font-size(14px);
        }
    }
}
</style>
